import Vue from 'vue'

import createLKStore from '../vue_widgets/report_configurations/locations_search_terms/store'
import LocationsSearchTerms from '../vue_widgets/report_configurations/locations_search_terms/index'
import reportConfigurations from '../vue_widgets/report_configurations/index/table'

function initForm(prms) {
  $(() => {
    const $form = $('#js-report-configuration-form')
    const $weekNumberSelect = $('.js-week-number-select')

    function initScheduleControls($currentTarget) {
      const currentVal = $currentTarget.val()
      if (currentVal === 'day_of_month') {
        $('.js-normal-report-config-schedule-params').hide()
        $('.js-hacked-report-config-schedule-params').show()
      } else {
        $('.js-normal-report-config-schedule-params').show()
        $('.js-hacked-report-config-schedule-params').hide()
      }
    }

    initScheduleControls($('[name="report_configuration[schedule_attributes][periodicity]"]:checked'))

    $('.js-location-tags').turboSelect({
      width: '100%',
      multiple: true,
      dropdownAutoWidth: 'true'
      // placeholder: 'Match locations by tags'
    })

    $form.find('#report_configuration_notified_user_ids')
      .turboSelect({ width: '100%', dropdownAutoWidth: 'true', multiple: true })
    $('[name="report_configuration[schedule_attributes][periodicity]"]').on('change', (e) => {
      const $currentTarget = $(e.currentTarget)
      $weekNumberSelect.prop('disabled', $currentTarget.val() === 'weekly')
      initScheduleControls($currentTarget)
    })

    /* eslint-disable no-new */
    new Vue({
      el: document.getElementById('vue-locations-keywords'),
      render: (h) => h(LocationsSearchTerms),
      store: createLKStore(prms)
    })
  })
}

Styxie.Initializers.ReportConfigurations = {
  edit: initForm,
  update: initForm,
  create: initForm,
  new: initForm,
  index: (params) => {
    $(() => {
      new Vue({
        el: document.getElementById('vue-report-configurations'),
        render: (h) => h(reportConfigurations, { props: params })
      })
    })
  }
}
